import { IActionComparator, INamespaceActionCreator, IReducer } from '@omaze/redux';

import { EMAIL_CAPTURE_ACTION } from '../email-capture-actions';
import {
    createEmailCaptureActionComparator,
    createEmailCaptureActionCreatorFactory,
    createEmailCaptureReducerFactory,
} from '../email-capture.factories';
import { IEmailCaptureState } from '../email-capture.state';

export const createResetEmailCaptureWithDelayStartAction: INamespaceActionCreator = createEmailCaptureActionCreatorFactory(
    EMAIL_CAPTURE_ACTION.RESET_EMAIL_CAPTURE_WITH_DELAY_START,
);

export const resetEmailCaptureWithDelayStartReducer: IReducer<IEmailCaptureState> = createEmailCaptureReducerFactory(
    EMAIL_CAPTURE_ACTION.RESET_EMAIL_CAPTURE_WITH_DELAY_START,
);

export const isResetEmailCaptureWithDelayStartAction: IActionComparator = createEmailCaptureActionComparator(
    EMAIL_CAPTURE_ACTION.RESET_EMAIL_CAPTURE_WITH_DELAY_START,
);
